import { createRoot } from 'react-dom/client';
import '@/index.css';
import App from '@/App';
import '@/locales/locales';

// Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";
// Bootstrap Bundle JS
import "bootstrap/dist/js/bootstrap.bundle.min";

import { initializeSentry } from './sentry';
import React from 'react';
import { AppGuard } from './components/guard/AppGuard';

initializeSentry(['production', 'staging']);

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
    <React.StrictMode>
        <AppGuard>
            <App />
        </AppGuard>
    </React.StrictMode>
);
